import React from 'react';
import { CheckedIcon, UncheckedIcon } from './CheckboxIcons';

type ValidInputLabelProps = {
    label: string;
    onClick?: () => void;
    showCheckbox?: boolean;
    checked?: boolean;
    noMinWidth?: boolean;
};

const ValidInputLabel = ({
    label,
    onClick,
    showCheckbox = false,
    checked,
    noMinWidth = false,
}: ValidInputLabelProps): JSX.Element => {
    return (
        <label
            className={`valid-input-label${noMinWidth ? ' no-min-width' : ''}`}
            onClick={onClick}
        >
            {showCheckbox ? (
                <div className="checkbox-icon-wrapper">
                    {checked ? (
                        <CheckedIcon className="checkbox-icon checked" />
                    ) : (
                        <UncheckedIcon className="checkbox-icon unchecked" />
                    )}
                </div>
            ) : null}
            <span className="label-text">{label}</span>
        </label>
    );
};

export default ValidInputLabel;
